import { Component, OnInit } from '@angular/core';
import {FacultyService} from "../../services/faculty.service";
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'app-facultyprofile',
  templateUrl: './facultyprofile.component.html',
  styleUrls: ['./facultyprofile.component.css', 'mobile.style.css']
})
export class FacultyprofileComponent implements OnInit {

  constructor(private facultyService: FacultyService,private route: ActivatedRoute,
      private router: Router,) { }


  thefaculty:any;
  isLoaded:boolean = false;
	  




  ngOnInit() {
  	this.route.params.subscribe( params => {
      this.facultyService.facultyProfile(params.fid).subscribe((result:any)=>{
        this.thefaculty = result;
        this.isLoaded = true;
        if (result == null) {
          this.router.navigate(['/faculty']);
        }
      })

    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/facultyprofile/facultyprofile.component.ts